export default "/wp-content/themes/onnit/script/cart/dist/wheyOverrideMobile-6bafdf4a.png";